module.exports = __webpack_public_path__ + "static/media/gmr.295347b0.svg";